"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _decorators = require("../../../../decorators");
var _mediaConfig = require("../../../../media-config");
var _imageUtils = require("../../../../utils/image-utils");
var _mediaUtils = require("../../../../utils/media-utils");
var _clone = _interopRequireDefault(require("lodash/clone"));
var _omit = _interopRequireDefault(require("lodash/omit"));
var _CloudinaryPicture = _interopRequireDefault(require("../../../CloudinaryPicture"));
var _VideoPlayer = require("../../../VideoPlayer");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
//helpers

//components

var StepMediaComponent = function StepMediaComponent(_ref) {
  var autoplayVideo = _ref.autoplayVideo,
    imageSizes = _ref.imageSizes,
    mediaUrl = _ref.mediaUrl,
    _ref$metadata = _ref.metadata,
    metadata = _ref$metadata === void 0 ? {} : _ref$metadata,
    onClickMedia = _ref.onClickMedia,
    refresh = _ref.refresh,
    shouldShowSpinnerWhileLoading = _ref.shouldShowSpinnerWhileLoading;
  var isVideo = (0, _mediaUtils.isVideoUrl)(mediaUrl);
  var eagerCacheConfig = (0, _clone["default"])(_mediaConfig.EAGER_CACHE['video'][0]);
  if (metadata && metadata.enableAudio) {
    delete eagerCacheConfig.audio_codec;
  }
  var cloudinaryMediaUrl = isVideo ? (0, _mediaUtils.getCloudinaryVideoUrl)(mediaUrl, (0, _mediaUtils.getExtensionFromUrl)(mediaUrl), (0, _mediaUtils.generateOptionString)(eagerCacheConfig)) : (0, _mediaUtils.getCloudinaryImageUrl)((0, _imageUtils.applyMetadata)(mediaUrl, (0, _omit["default"])(metadata, 'focus')));
  if (isVideo) {
    return /*#__PURE__*/_react["default"].createElement(_VideoPlayer.VideoPlayerMobile, {
      autoplayVideo: autoplayVideo,
      muted: !metadata.enableAudio,
      poster: (0, _mediaUtils.getThumbnail)(mediaUrl),
      src: cloudinaryMediaUrl,
      type: 'video/' + (0, _mediaUtils.getFixedExtensionFromUrl)(mediaUrl)
    });
  }
  return /*#__PURE__*/_react["default"].createElement(_CloudinaryPicture["default"], {
    onClick: function onClick() {
      if (typeof onClickMedia === 'function') {
        onClickMedia({
          cloudinaryMediaUrl: cloudinaryMediaUrl
        });
      }
    },
    restartAnimation: refresh,
    shouldShowSpinnerWhileLoading: shouldShowSpinnerWhileLoading,
    shouldShowOverlayShapes: true,
    aspectRatio: 4 / 3,
    metadata: metadata,
    src: mediaUrl,
    sizes: imageSizes
  });
};
var _default = exports["default"] = (0, _decorators.styleable)(StepMediaComponent);
//# sourceMappingURL=index.js.map